import React, { useState, useEffect } from 'react';
import {
	Modal,
	Button,
	Group,
	Stack,
	Divider,
	Title,
	Text,
	MultiSelect,
	TagsInput
} from '@mantine/core';
import { ListUserDto } from '../../models/user.models';
import { ListTeamDto } from '../../models/team.models';

export enum EmailType {
	WorkOrder = 1
}

export const EmailTypeLabels: Record<EmailType, string> = {
	[EmailType.WorkOrder]: "Work Order"
};

type SendEmailModalProps = {
	emailType: EmailType;
	visible: boolean;
	onCancel: () => void;
	onSend: (users: ListUserDto[], teams: ListTeamDto[], customEmails: string[]) => void;
	isSending?: boolean;
	users: ListUserDto[];
	teams: ListTeamDto[];
};

const SendEmailModal: React.FC<SendEmailModalProps> = ({
	emailType,
	visible,
	onCancel,
	onSend,
	isSending = false,
	users,
	teams,
}) => {
	const [selectedUserIds, setSelectedUserIds] = useState<string[]>([]);
	const [customEmails, setCustomEmails] = useState<string[]>([]);
	// const [emailInput, setEmailInput] = useState('');
	// const [emailError, setEmailError] = useState(false);

	useEffect(() => {
		if (visible) {
			setSelectedUserIds([]);
			setCustomEmails([]);
			// setEmailInput('');
			// setEmailError(false);
		}
	}, [visible]);

	const isValidEmail = (email: string) => {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
	};

	const handleSend = () => {
		const selectedUsers = users.filter((u) => selectedUserIds.includes(u.UserId));
		const selectedTeams = teams.filter((t) => selectedUserIds.includes(t.TeamId));
		onSend(selectedUsers, selectedTeams, customEmails);
		// setSelectedUserIds([]);
		// setCustomEmails([]);
		// setEmailInput('');
	};

	return (
		<Modal
			title={<Title order={4}>Email {EmailTypeLabels[emailType]} to Recipients</Title>}
			opened={visible}
			onClose={onCancel}
			size="md"
		>
			<Stack>
				<MultiSelect
					label="Select Recipients"
					data={[
						{
							group: 'Teams',
							items: teams.map((team) => ({ value: team.TeamId, label: team.Name })),
						},
						{
							group: 'Users',
							items: users.map((user) => ({ value: user.UserId, label: user.Name })),
						},
					]}
					value={selectedUserIds}
					onChange={setSelectedUserIds}
					placeholder="Pick users and teams"
					searchable
					clearable
				/>
				{/* <Divider label="Add Email Recipient" labelPosition="left" my="xs" /> */}
				<Text fz="sm">Add Custom Email Recipients</Text>
				<TagsInput
					placeholder="Enter email addresses"
					value={customEmails}
					onChange={(values) => {
						const validEmails = values.filter((email) => isValidEmail(email));
						setCustomEmails(validEmails);
					}}
					error={customEmails.some((email) => !isValidEmail(email)) ? 'Invalid email address' : false}
				/>
				{/* <Divider my="xs" /> */}
				<Group justify="right" mt="md">
					<Button variant="outline" onClick={onCancel} disabled={isSending} radius="lg">Cancel</Button>
					<Button
						disabled={selectedUserIds.length === 0 && customEmails.length === 0}
						loading={isSending}
						onClick={handleSend}
						radius="lg"
					>
						Send
					</Button>
				</Group>
			</Stack>
		</Modal>
	);
};

export default SendEmailModal;